
/** アラートメッセージなどのヘルパー関数群 */

/**
 * メッセージのキー指定を置き換えて返却する
 * - 複数key利用可能
 * @param message メッセージ本文
 * @param params key:valueのオブジェクト
 * - 例）{name1:"田中", name2: "佐藤"}
 * @returns 変換後の文字列
 */
export function formatMessage(message: string, params:{[key:string]:string}): string {
    // 正規表現で「{}」を探索する
    return message.replace(/{(\w+)}/g, (match, key) => params[key] || match);
}